export default __webpack_public_path__ + "static/media/2.a5e3be2d.png";